module.exports = __webpack_public_path__ + "media/images/pla/pla1-21453cbc773047016a628d34b305d8f7.jpg";